import React, { useRef, useState, useEffect } from "react";
import { useGetApprovalListingQuery, useUpdateApprovalMutation, useGetTripcheckpointMutation, useUpdateUserTableHeadersMutation, usePassOnApprovalMutation, useReCallApprovalMutation,useApprovalGateOutMutation } from "../../api/vmsSlice";
import { useUserDetail, useUserPermissions, useUserTableHeader } from "../../services/hooks";
import { GenericTable, tCell, ActionMenu, toastMessage, TableColumnCustomizer } from "../utils";
import { Dialog } from "../utils";
import { formatDate, findDeepValue, capitalizeCamelCase, removeSpecialChars, debounce } from "../../services/functions";
import "./Approval.css";
import { Navigate } from "react-router-dom/dist";
import { Checkbox, Button,  Input } from "../utils";
import { buttonClasses } from "../utils/theme";
import DynamicFormRender from "../Dynamic/DynamicForm";
import Genericfilter from "../utils/Genericfilter";
import { checkForFlags } from "../Dynamic/helper";
import { useSocketContext } from "../../context/socketContext";
import CommonTour, { TourIcon } from "../Tour/CommonTour";

const REJECT = "reject";
const APPROVE = "approve";
const HOLD = "hold";
const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};
const approvalStatusMap = {
	approve: "Approved",
	reject: "Rejected",
	hold: "Hold",
};

const dummyTourData = [
	{
		_id: "68199032c76710aa643a124b",
		approvalStatus: "Approved",
		approvalTemplateID: "670905ef06862528b32958a6",
		created_by: {
			user_id: "65fbd96d6bc11b2703fac28d",
			user_type: "admin",
			name: "ashishAdmin",
			email: "ashishtest@gmail.com",
		},
		created_on: "2025-05-06T04:29:38.421Z",
		currentApprovalConfig: "67092776f5a316064a20c228",
		current_checkpoint_name: "access management",
		current_checkpoint_no: 1,
		driverName: "John Doe",
		driverNumber: "9000000000",
		//   vehicleId: "67a0b563ff47a31b42b26950",
		fallbackWorkflowId: "66ed3a8452abaf750816da1b",
		inTime: "2025-05-06T04:29:38.327Z",
		isApproved: true,
		location: { latitude: -90, longitude: -90 },
		modified_on: "2025-05-06T04:29:53.966Z",
		orgId: "65fbd1a953312156626a627d",
		outTime: null,
		product: [
			{
				productName: "Meals on Wheels",
				_id: "66e43589ef777c8ccc1be0b8",
				priority: 1,
				productCategory: {
					productCategory: "Orgainc Matter",
					_id: "66277b5b14e79a6f9feb2e86",
				},
			},
		],
		rejectTemplateId: "67cac53896efd616b930e2b3",
		status: "accessManagement",
		statusHistory: [
			{
				_id: "68199032c76710aa643a1244",
				checkInDataID: "68199032c76710aa643a1244",
				approvalStatus: "Approved",
				checkpointId: "660a84dd01071b25bd87c195",
				checkpointNumber: 1,
				checkpointType: "access",
				currentApprovalConfig: "67092776f5a316064a20c228",
				displayName: "access management",
				inTime: "2025-05-06T04:29:38.421Z",
				outTime: "2025-05-06T04:29:53.966Z",
				type: "manual",
				userDetails: {
					userId: "65fbd96d6bc11b2703fac28d",
					userType: "admin",
					userRoleId: "65fbd93f6bc11b2703fac239",
				},
				supplier: {
					supplierName: "Los Pollos Hermanos",
					supplierId: "0001",
					_id: "660a973d01071b25bd87c8f2",
				},
				templateId: "667d30e8013d34503aea1715",
				trip_counter: "AM25-26MGFnsKS157",
				trip_over: true,
				trip_status: "Terminated",
				vehicleId: "67a0b563ff47a31b42b26950",
				vehicleNumber: "XX00XX0000",
			},
		],
		workFlowId: "66ed3a8452abaf750816da1b",
		trip_over: true,
		trip_status: "Terminated",
		vehicleId: "67a0b563ff47a31b42b26950",
		vehicleNumber: "XX00XX0000",
		__v: 0,
	},
];
const tourSteps = [
	{
		target: ".title", // The approval management title
		content: "Welcome to the Approval Management system. Here you can review and process pending approvals.",
		placement: "bottom",
	},
	// {
	// 	target: ".filters", // Filter component
	// 	content: "Use these filters to find specific approvals you need to process.",
	// 	placement: "bottom",
	// },
	{
		target: "#GenericTable", // Table component
		content: "This table shows all pending approvals. Each row represents a trip that needs your review.",
		placement: "top",
	},
	{
		target: ".ApprovalCheckbox", // The action menu in each row
		content: "For individual approvals, use these action buttons to approve, reject, hold, or move to a specific checkpoint.",
		placement: "right",
	},
	{
		target: ".multiActions", // Action buttons div
		content: "Select approvals using checkboxes in table row, then use these buttons to approve, reject, or hold multiple items at once.",
		placement: "bottom",
	},
	{
		target: ".customizeTableButton", // Customize Table button
		content: "Click here to customize which columns are visible in the table. You can show/hide columns to suit your workflow.",
		placement: "left",
	},
];

export default function ApprovalIndex() {
	const { userPermissions, isFetched } = useUserPermissions();
	const { userDetail } = useUserDetail();
	const tourRef = useRef();
	const [isTourMode, setIsTourMode] = useState(false);
	const shouldRunTour = !userDetail?.moduleTour?.approvalManagement;
	const filterRef = useRef(defaultFilter);
	const { page_no, pagesize } = filterRef.current;
	const [selectedTickets, setSelectedTickets] = useState([]);
	const [selectedSubMenu, setSelectedSubMenu] = useState("")
	const [moveToList, setMoveToList] = useState([]);
	const [passOnList, setPassOnList] = useState([]);
	const [menuloading, setMenuLoading] = useState(false);
	const [approvalAction, setApprovalAction] = useState("");
	const [approvalTemplateId, setApprovalTemplateId] = useState([]);
	const [approvalPayload, setApprovalPayload] = useState({});
	const [isTourRunning, setIsTourRunning] = useState(true);
	const { userTableHeaders, getUserTableHeaders } = useUserTableHeader();
	const [updateTableHeader] = useUpdateUserTableHeadersMutation();
	const [updateTicketTrigger] = useUpdateApprovalMutation();
	const [getTripcheckpointTrigger] = useGetTripcheckpointMutation();
	
	const { data, isLoading, refetch, isFetching } = useGetApprovalListingQuery(filterRef.current, { refetchOnMountOrArgChange: true, pollingInterval: 30000, });
	let { data: approvalList, tableHeader = [], count } = data || { data: [] };
	const {
		socketData: { approvalEvents },
		clearApprovalEvents
	} = useSocketContext();
	
	const filteredApprovals = approvalList?.length || approvalEvents?.length ? checkApprovalList(approvalList, approvalEvents) : [];


	useEffect(() => {
		getUserTableHeaders({ template_id: "approval_listing" });
	}, [filterRef.current]);

	useEffect(() => {
		if (!isFetching && approvalList?.length) {
			clearApprovalEvents();
		}
	}, [approvalList]);

	let header = ["S.No", ...(tableHeader || []).map((_) => _.label), "Action"];
	let actionHandlers = {};
	const checkoutDataRef = useRef([]);

	actionHandlers.approve = (index) => {
		const entry = filteredApprovals[index];
		const { _id } = entry;
		const payload = {
			reference_id: [_id],
			// formData: { remarks: "done" },
			// formData: { remarks: "done" },
			approvalStatus: "Approved",
			module: "accessManagement",
		};
		if (filteredApprovals[index].approvalTemplateID) {
			setApprovalAction("Approve");
			payload.formData = { remark: "done" };
			setApprovalPayload([payload]);
			setApprovalTemplateId([filteredApprovals[index].approvalTemplateID]);
			checkoutDataRef.current = [entry];
		} else {
			updateTicketTrigger({ ...payload })
				.unwrap()
				.then((res) => {
					// console.log(res);
					if (res.error) {
						toastMessage(false, res.message);
					} else {
						toastMessage(true, `Trip is updated successfully`);
						setSelectedTickets([]);
					}
				})
				.catch((err) => {
					// console.log("error updating approval", err);
				});
		}

		// console.log('approve clicked', payload, entry);
	};
	actionHandlers.reject = (index) => {
		const entry = filteredApprovals[index];
		const { _id } = entry;

		const payload = {
			reference_id: [_id],
			approvalStatus: "Rejected",
			isRejected: true,
			module: "accessManagement",
		};
		if (filteredApprovals[index].rejectTemplateId) {
			setApprovalAction("Reject");
			setApprovalPayload([payload]);
			setApprovalTemplateId([filteredApprovals[index].rejectTemplateId]);
			checkoutDataRef.current = [entry];
		} else {
			updateTicketTrigger({ ...payload })
				.unwrap()
				.then((res) => {
					// console.log(res);
					if (res.error) {
						toastMessage(false, res.message);
					} else {
						toastMessage(true, `Trip is updated successfully`);
					}
				})
				.catch((err) => {
					// console.log("error updating approval", err);
				});
		}

		// console.log('reject clicked', payload);
	};
	actionHandlers.hold = (index) => {
		const entry = filteredApprovals[index];
		const { _id } = entry;
		const payload = {
			reference_id: [_id],
			approvalStatus: "Hold", // will follow the format moveTo-checkpointStatus,
			module: "accessManagement",
		};
		updateTicketTrigger({ ...payload })
			.unwrap()
			.then((res) => {
				// console.log(res);
				if (res.error) {
					toastMessage(false, res.message);
				} else {
					toastMessage(true, `Trip is updated successfully`);
				}
			})
			.catch((err) => {
				// console.log("error updating approval", err);
			});
		// if (filteredApprovals[index].approvalTemplateID) {
		// 	setApprovalAction("Hold");
		// 	setApprovalPayload([payload]);
		// 	setApprovalTemplateId([filteredApprovals[index].approvalTemplateID]);
		// 	checkoutDataRef.current = [entry];
		// } else {
		// }

		// console.log('hold clicked', payload);
	};
	actionHandlers.moveTo = (index) => {
		const entry = filteredApprovals[index];
		const { _id } = entry;
		setMenuLoading(true);
		getTripcheckpointTrigger({ tripId: _id })
			.unwrap()
			.then((res) => {
				if (res.error) {
					setMenuLoading(false);
					toastMessage(false, res.message);
				} else {
					const checkpointList = res.data;
					setMoveToList(
						checkpointList.map((checkpoint) => ({
							label: checkpoint.displayName,
							value: checkpoint.checkpointNumber,
						}))
					);
					setMenuLoading(false);
				}
			})
			.catch((err) => {
				setMenuLoading(false);
				toastMessage(false, "Error fetching trip checkpoint data");
				// console.log("error fetching trip checkpoint data", err);
			});

		// console.log('moveto clicked', entry);
	};
	actionHandlers.passOn = (index) => {
		const entry = filteredApprovals[index];
		const { _id, current_checkpoint_no } = entry;
		setMenuLoading(true);
		getTripcheckpointTrigger({ tripId: _id, type : "passOn" })
			.unwrap()
			.then((res) => {
				if (res.error) {
					setMenuLoading(false);
					toastMessage(false, res.message);
				} else {
					const checkpointList = res.data;
					console.log("passOn checkpointList", checkpointList, current_checkpoint_no);
					setPassOnList(
						checkpointList.filter((el)=> current_checkpoint_no !== el.checkpointNumber).map((checkpoint) => ({
							label: checkpoint.displayName,
							value: checkpoint._id,
						}))
					);
					setMenuLoading(false);
					if(checkpointList.length === 0 ){
						toastMessage(false, "No checkpoints available for Pass On");
					}
				}
			})
			.catch((err) => {
				toastMessage(false, "Error fetching trip checkpoint data");
				// console.log("error fetching trip checkpoint data", err);
			});
		// console.log('moveto clicked', entry);
	};
	actionHandlers.gateOut = (index) => {
		console.log("GateOut clicked for index:", index);
		const entry = filteredApprovals[index];
		const payload = {
			tripId: entry._id,
			action : "gateout",
			title : `Reject to Gate Out`
		};

		setSelectedSubMenu(payload)
	};

	const onModalClose = () => {
		setApprovalTemplateId([]);
		setApprovalPayload({});
		setSelectedTickets([]);
		setApprovalAction("");
		checkoutDataRef.current = [];
	};

	const handleChildMenuClick = (item, index) => {
		const entry = filteredApprovals[index];
		if (!entry) return;

		const { _id } = entry;
		console.log("handleChildMenuClick", item);
		switch (item.parent) {
			case "passOn": {
				const payload = {
					tripId: _id,
					checkpointId: item.value,
					action : "passOn",
					title : `Pass On to ${item.label}`
				};

				setSelectedSubMenu(payload)
				console.log("passOn-secondmenu clicked", payload);
				return;
			}

			case "moveTo": {
				const payload = {
					reference_id: [_id],
					approvalStatus: `moveTo-${item.label}`,
					toCheckpoint: item.value,
					module: "accessManagement",
				};

				// console.log("moveTo-secondmenu clicked", payload);

				if (entry.approvalTemplateID) {
					setApprovalAction("Move to");
					setApprovalPayload([payload]);
					setApprovalTemplateId([entry.approvalTemplateID]);
				} else {
					updateTicketTrigger(payload)
						.unwrap()
						.then((res) => {
							if (res.error) {
								toastMessage(false, res.message);
							} else {
								toastMessage(true, "Trip is updated successfully");
							}
						})
						.catch(() => {});
				}
				return;
			}

			default:
				console.warn("Unknown action:", action);
		}
	};

	const handleApprovalRecall = (index) => {
		const entry = filteredApprovals[index];
		// console.log("handleApprovalRecall", entry, index);
		const payload = {
			tripId: entry._id,
			action : "revoke",
			title : `Revoke Approval`
		};

		setSelectedSubMenu(payload)
		// console.log("recall-secondmenu clicked", payload);
	}


	const handleMultiAction = (action) => {
		let payload;
		let selectedTicket = [];
		let approvalPayload = [];
		let approvalTemplateId = [];
		selectedTickets.forEach((el, index) => {
			const temp = filteredApprovals.find((e) => e._id === el);
			if (action == "reject" && !temp.rejectTemplateId) {
				selectedTicket.push(el);
			} else if (action == "hold") {
				selectedTicket.push(el);
			} else if (temp.approvalTemplateID || temp.rejectTemplateId) {
				let payloadd = {
					reference_id: [el],
					module: "accessManagement",
					approvalStatus: approvalStatusMap[action],
					isRejected: action == REJECT,
				};
				approvalPayload.push(payloadd);

				if (action == REJECT && temp.rejectTemplateId) {
					approvalTemplateId.push(temp.rejectTemplateId);
				} else if (temp.approvalTemplateID) {
					approvalTemplateId.push(temp.approvalTemplateID);
				}
				// checkout data
				if (!checkoutDataRef.current) checkoutDataRef.current = [];
				checkoutDataRef.current.push(temp);
			} else {
				selectedTicket.push(el);
			}
			// if (temp.approvalTemplateID || temp.rejectTemplateId ) {
			// 	let payloadd = {
			// 		reference_id: [el],
			// 		module: "accessManagement",
			// 		approvalStatus: approvalStatusMap[action],
			// 		isRejected: action == REJECT,
			// 	};
			// 	approvalPayload.push(payloadd);

			// 	if (action == REJECT && temp.rejectTemplateId) {
			// 		approvalTemplateId.push(temp.rejectTemplateId);
			// 	} else if (temp.approvalTemplateID) {
			// 		approvalTemplateId.push(temp.approvalTemplateID);
			// 	}
			// 	// checkout data
			// 	if (!checkoutDataRef.current) checkoutDataRef.current = [];
			// 	checkoutDataRef.current.push(temp);
			// } else {
			// 	selectedTicket.push(el);
			// }
		});

		payload = {
			reference_id: selectedTicket,
			module: "accessManagement",
			approvalStatus: approvalStatusMap[action],
			isRejected: action == REJECT,
		};
		// console.log("handleMultiAction", selectedTicket, approvalPayload, approvalTemplateId, payload);
		if (selectedTicket.length > 0) {
			updateTicketTrigger({ ...payload })
				.unwrap()
				.then((res) => {
					// console.log(res);
					if (res.error) {
						toastMessage(false, res.message);
					} else {
						setSelectedTickets([]);
						if (res?.additionalSuccessMessage) {
							const { pass, fail } = CheckResponse(res.additionalSuccessMessage);
							toastMessage(true, `${pass} Trip is updated ${fail ? `${fail} Trip is failed to update` : ``}`);
						} else {
							toastMessage(true, `Trip is ${res.message}`);
						}
					}
				})
				.catch((err) => {
					// console.log("error updating approval", err);
				});
		}
		setApprovalPayload(approvalPayload);
		setApprovalTemplateId(approvalTemplateId);
	};

	const handleTrip = (ticket) => {
		// console.log('handleTrip', ticket);
		setSelectedTickets((prev) => {
			const index = prev.findIndex((t) => t === ticket);
			if (index === -1) {
				return [...prev, ticket];
			} else {
				return prev.filter((t) => t !== ticket);
			}
		});
	};
	function checkApprovalList(list, socketList) {
		if (!list?.length) {
			return socketList;
		}
		return [...socketList.filter((item) => !list.some((_) => _._id == item._id)), ...list];
	}

	// console.log("filteredApprovals", filteredApprovals);
	const rows = (shouldRunTour || isTourMode ? dummyTourData : filteredApprovals)?.map((d, i) => {
		let row = [];
		// for showing the latest socket event bg color in table listing
		row.bgColor = d.bgColor;
		row.push(
			<div style={{ display: "flex", alignItems: "center", justifyContent: "start" }} className="ApprovalCheckbox">
				<Checkbox
					disabled={["Cancelled", "Terminated"].includes(d.trip_status) ? true : ["Rejected", "Approved", "RejectToGateout"].includes(d.approvalStatus) ? true : false}
					checked={selectedTickets.includes(d._id) ? true : false}
					onChange={() => handleTrip(d._id)}
					name={"trip_id"}
				/>
				{(page_no - 1) * pagesize + i + 1}
			</div>
		);
		for (let item of tableHeader) {
			row.push(tCell(item.type === "date" ? formatDate(findDeepValue(d, item.name.split("."))) : findDeepValue(d, item.name.split("."))));
		}
		let _action = { approve : actionHandlers.approve, reject : actionHandlers.reject, hold : actionHandlers.hold} 
		if(userPermissions?.manageApprovalMoveTo?.value === true){
			_action = { ..._action, moveTo : actionHandlers.moveTo};
		}
		if(userPermissions?.manageApprovalPassOn?.value === true && d.product.length > 1){
			_action = { ..._action, passOn : actionHandlers.passOn};
		}
		if(userPermissions?.manageApprovalGateOut?.value === true && d.product.length > 1){
			_action = { ..._action, rejectToGateOut : actionHandlers.gateOut};
		}
		const ActionStatus = () => {
			const term = /terminated/i;
			const canc = /cancelled/i;
			const passOn = /passon/i;
			if (term.test(d.trip_status) || canc.test(d.trip_status)) {
				if (/approved/i.test(d.approvalStatus)) {
					return <span className="status green">{capitalizeCamelCase(removeSpecialChars(d.approvalStatus))}</span>;
				} else {
					return <span className="status red">{capitalizeCamelCase(removeSpecialChars("Rejected"))}</span>;
				}
			}else if ((d.approvalStatus === "Pending" || passOn.test(d.approvalStatus)) && !d.hasOwnProperty("isApproved")) {
				return <ActionMenu 
					id={i} 
					handlers={_action} 
					childMenuOpen={d.product.length > 1 ? ["moveTo", "passOn"] : ["moveTo"]} 
					childMenu={d?.product?.length > 1 ? {"moveTo" : moveToList, "passOn" : passOnList} : {"moveTo" : moveToList}} 
					handleChildMenuClick={(id) => handleChildMenuClick(id, i)} 
					loading={menuloading}
				/>; // Component to show all 4 buttons
			} else if (d.approvalStatus === "Approved" && d.isApproved === true) {
				return <div>
					<span className="status green">{capitalizeCamelCase(removeSpecialChars(d.approvalStatus))}</span><br/>
					{d.approval_recall && userPermissions?.manageApprovalRevoke?.value === true ? <span onClick={(id) => handleApprovalRecall(i)} className="status" style={{cursor: "pointer", backgroundColor: "var(--primary-color)"}}>Revoke Approval</span> : null} 
				</div>; // Component to just show status
			} else if (d.approvalStatus.includes("moveTo")) {
				delete _action.hold;
				delete _action.moveTo;
				// delete _action.passOn;
				return <ActionMenu id={i} handlers={_action} childMenuOpen={d.product.length > 1 ? ["passOn"] : []} childMenu={d?.product?.length > 1 ? {"passOn" : passOnList} : {}} handleChildMenuClick={(id) => handleChildMenuClick(id, i)}    />; // Component to show only approve and reject buttons
			} else if (d.approvalStatus === "Rejected" && d.isApproved === false) {
				return <span className="status red">{capitalizeCamelCase(removeSpecialChars(d.approvalStatus))}</span>; // Component to just show status
			} else if (d.approvalStatus.includes("Hold")) {
				delete _action.hold;
				delete _action.passOn;
				return <ActionMenu id={i} handlers={_action} childMenuOpen={["moveTo"]} childMenu={{"moveTo" : moveToList}} handleChildMenuClick={(id) => handleChildMenuClick(id, i)} loading={menuloading}/>;
				// return (
				//     <span className="status yellow">
				//         {capitalizeCamelCase(removeSpecialChars(d.approvalStatus))}
				//     </span>
				// ) // Component to just show status
			}
		};

		row.push(ActionStatus());
		return row;
	});

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		refetch(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value, page_no: 1 };
		refetch(filterRef.current);
	};

	const onUpdateSuccess = () => {
		getUserTableHeaders({ template_id: "approval_listing" });
	};
	const updateTableColumn = async (selectedArray) => {
		const updateTableHeaderPayload = {
			template_id: "approval_listing",
			selected_headers: selectedArray,
		};
		if (updateTableHeaderPayload) {
			const {
				data: { error, message },
			} = await updateTableHeader(updateTableHeaderPayload);
			if (error) {
				toastMessage(false, message);
			} else {
				toastMessage(true, message);
				onUpdateSuccess();
				refetch(filterRef.current);
			}
		}
	};
	const typeToInputType = {
		date: "datePicker",
		dropdown: "dropdown",
		searchDropdown: "searchDropdown",
	};
	let filterFields = [
		{ inputType: "dateRangePicker", id: "dateRange", name: "dateRange", label: "Request Time", startKey: "start", endKey: "end", value: "", style: { marginTop: "6px" } },
		...tableHeader
			?.filter((_) => _.isSearchable)
			.map((_) => ({
				inputType: typeToInputType[_.type] || "textfield",
				id: _.name,
				name: _.name,
				type: _.type || "text",
				label: _.label,
				placeholder: _.label,
				readOnly: false,
				error: "",
				value: "",
			})),
	];
	const handleFilterChange = (filter) => {
		// console.log(filter);
		/**
		 *	eg: filter = { vehicleNumber: "abc", "productCategory.productCategory": "def", "product.productName": "ghi" }
		 
			_filter = [
				{ path: "vehicleNumber", value: "abc"},
				{ path: "productCategory.productCategory", value: "def"},
				{ path: "product.productName", value: "ghi"},
			]
		 */
		const { start, end, ...rest } = filter;
		let _filters = Object.keys(rest).filter((key) => key !== "dateRange").map((key) => ({ path: key, value: rest[key] }));
		filterRef.current = { ...filterRef.current, filters: _filters, start: start || "", end: end || "", page_no: 1 };
		refetch();
	};
	const handleTourStart = () => {
		setIsTourMode(true);
		tourRef.current?.restartTour();
	};
	if (isFetched && userPermissions && Object.keys(userPermissions).length && userDetail && !(userDetail?.userRole == "bayOperator" || userPermissions?.manageApprovals?.value))
		return <Navigate to="/not-authorized" replace />;

	return (
		<div className="contentpanel">
			<CommonTour ref={tourRef} steps={tourSteps} moduleName="approvalManagement" onTourComplete={() => setIsTourMode(false)} />
			<div className="cust-row flex-algn-cent" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div className="cust-col-5">
					<h1 className="title">
						Approval Management{" "}
						<span onClick={handleTourStart}>
							<TourIcon />
						</span>
					</h1>
				</div>
				<div className="customizeTableButton">
					<TableColumnCustomizer tableColumList={userTableHeaders} onApply={(selected) => updateTableColumn(selected)} />
				</div>
			</div>
			<hr className="bgg" style={{ marginBottom: "1rem" }} />
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<div className="filters">
					<Genericfilter filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} addOnClear />
				</div>
			</div>

			{(shouldRunTour || isTourMode ? dummyTourData : selectedTickets.length > 0) && (
				<div style={{ display: "flex", justifyContent: "start", gap: "20px", marginBottom: "20px", width: "fit-content" }} className="multiActions">
					<Button onClick={() => handleMultiAction(APPROVE)} text={"Approve"} style={{ ...buttonClasses.lynkitGreenFill, width: "100px" }} />
					<Button onClick={() => handleMultiAction(REJECT)} text={"Reject"} style={{ ...buttonClasses.lynkitRedFill, width: "100px" }} />
					<Button onClick={() => handleMultiAction(HOLD)} text={"Hold"} style={{ ...buttonClasses.lynkitYellowFill, width: "100px" }} />
				</div>
			)}
			<div className="main_content" id="GenericTable">
				<GenericTable
					header={header}
					rows={rows}
					pageCount={count}
					pageNo={filterRef.current.page_no}
					limit={filterRef.current.pagesize}
					onPageChange={onPageChange}
					onPageSizeChange={onPageSizeChange}
					isLoading={isFetching}
				/>
			</div>
			{approvalTemplateId?.length > 0 && approvalPayload?.length > 0 && (
				<ApprovalForm
					open={approvalTemplateId}
					onClose={onModalClose}
					templateId={approvalTemplateId}
					payload={approvalPayload}
					approvalList={filteredApprovals}
					approvalAction={approvalAction}
					checkoutDataArr={checkoutDataRef.current}
				/>
			)}

			<RemarkForm
				open={selectedSubMenu?.tripId}
				onClose={() => setSelectedSubMenu(null)}
				payload={selectedSubMenu} 
			/>
		</div>
	);
}

function CheckResponse(errorArr) {
	const res = { pass: 0, fail: 0 };
	errorArr.forEach((ele, index) => {
		if (!ele.error) {
			res["pass"] = res["pass"] + 1;
		} else {
			res["fail"] = res["fail"] + 1;
		}
	});

	return res;
}

function ApprovalForm({ onClose, open, templateId, payload, approvalList, approvalAction, checkoutDataArr }) {
	const [updateTicketTrigger] = useUpdateApprovalMutation();
	const [hideTemplate, setHideTemplate] = useState([]);
	const { userDetail } = useUserDetail();
	const handleFormSubmit = async (data, index) => {
		const checkpointName = checkoutDataArr[index]?.current_checkpoint_name;
		let Payload = { ...payload[index], formData: data.data, approvalTemplateId: templateId[index] };
		checkForFlags(Payload.formData, checkpointName, userDetail?.email);
		// console.log("submit on dynamic", Payload, index, payload, templateId);

		await updateTicketTrigger({ ...Payload })
			.unwrap()
			.then((res) => {
				// console.log(res);
				if (res.error) {
					toastMessage(false, res.message);
				} else {
					toastMessage(true, `Trip is updated successfully`);
					if (hideTemplate.length === templateId.length - 1) {
						handleClose();
					} else {
						setHideTemplate((prev) => [...prev, index]);
					}
				}
			})
			.catch((err) => {
				// console.log("error updating approval", err);
			});
	};
	const handleClose = () => {
		onClose();
	};

	// if (isLoading) return <Loader size="3rem" height="100%" />;
	// if (isInValidCheckpoint) return <Navigate to={REDIRECTION_URL} replace={true} />;

	return (
		<Dialog size="lg" open={true} handleClose={onClose} title={approvalAction} noBtn>
			{templateId.map((el, index) => (
				<div key={`${el}-${index}`}>
					{approvalList ? (
						<span style={{ fontSize: "15px", fontWeight: "bold" }}> Trip Id : {approvalList.find((e) => e._id === payload[index].reference_id[0]).trip_counter || ""}</span>
					) : null}
					{!hideTemplate.includes(index) && (
						<DynamicFormRender
							templateId={el}
							checkpointId={""}
							onClose={handleClose}
							onSubmit={(data) => handleFormSubmit(data, index)}
							checkoutData={checkoutDataArr[index]}
							// isSubmitDisabled={isSubmitting}
						/>
					)}
				</div>
			))}
		</Dialog>
	);
}

function RemarkForm({ onClose, open, payload}) {
	const [remark, setRemark] = useState("");
	const [error, setError] = useState("");
	const [passOnApprovalTrigger] = usePassOnApprovalMutation();
	const [reCallApprovalTrigger] = useReCallApprovalMutation();
	const [approvalGateOutTrigger] = useApprovalGateOutMutation();

	const getWordCount = (text) => {
		return text
		.trim()
		.split(/\s+/)
		.filter(Boolean).length;
	};

	const handleSubmit = () => {
		const wordCount = getWordCount(remark);
		if (!remark.trim()) {
			setError("Remark is required");
			return;
		}
		if (wordCount > 100) {
			setError("Remark should not exceed 100 words");
			return;
		}

		setError("");

		if(payload.action === "passOn"){
			const payloadBody = {
				tripId: payload.tripId,
				checkpointId: payload.checkpointId,
				formData :{"remark" : remark}
			};

			// console.log("passOn-secondmenu popup clicked", payloadBody);
			passOnApprovalTrigger(payloadBody)
				.unwrap()
				.then((res) => {
				if (res.error) {
					toastMessage(false, res.message);
				} else {
					toastMessage(true, "approval pass on successfully");
					handleClose()
				}
				})
				.catch(() => {});
			
		}

		if(payload.action === "revoke"){
			const payloadBody = {
				tripId: payload.tripId,
				formData :{"remark" : remark}
			};

			// console.log("passOn-secondmenu revoke clicked", payloadBody);
			reCallApprovalTrigger(payloadBody)
				.unwrap()
				.then((res) => {
					if (res.error) {
						toastMessage(false, res.message);
					} else {
						toastMessage(true, "approval recall successfully");
						handleClose()
					}
				})
				.catch(() => {});
		}	

		if(payload.action === "gateout"){
			const payloadBody = {
				tripId: payload.tripId,
				formData :{"remark" : remark}
			};

			// console.log("passOn-secondmenu gateout clicked", payloadBody);
			approvalGateOutTrigger(payloadBody)
				.unwrap()
				.then((res) => {
					if (res.error) {
						toastMessage(false, res.message);
					} else {
						toastMessage(true, "vehicle reject to gate out successfully");
						handleClose()
					}
				})
				.catch((err) => {
					setMenuLoading(false);
					toastMessage(false, err);
					// console.log("error fetching trip checkpoint data", err);
				});
		}
  	};

	const handleClose = () => {
		setRemark("")
		setError("")
		onClose();
	}
	

	return (
    <Dialog size="lg" open={open} handleClose={handleClose} title={payload?.title || ""} noBtn>
      <div style={{display : "flex", flexDirection : "column"}}>
        <Input
          id={"remark"}
          name={"remark"}
          type={"number"}
          label={"Remarks"}
          placeholder={"Enter Remarks"}
		  value={remark}
		  onChange={(e) => setRemark(e.target.value)}
		  error={error}
		  multiline
          rows={4}
        />
        <div style={{display : "flex", justifyContent : "center", marginTop : "10px"}}>
			<Button className="" text="Submit" style={{...buttonClasses.lynkitOrangeFill, width: "10%"}} onClick={handleSubmit} />
		</div>
      </div>
    </Dialog>
  );
}
